var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Track Art")]),_vm._v(" "),_c('h3',[_vm._v("Artist Name")]),_vm._v(" "),_c('p',[_vm._v("Track Title")]),_vm._v(" "),_c('p',[_vm._v("Genre")]),_vm._v(" "),_c('p',[_vm._v("stuff goes here")]),_vm._v(" "),_c('h3',[_vm._v("vote count her but not rendered")])])
}]

export { render, staticRenderFns }